module.exports = __webpack_public_path__ + "static/media/icecast.61f621b2.png";